import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 出入金約定與其他財力證明 ViewData
 */
const ConfirmationViewData = [
    'POST',
    RouteUrlList.API_ConfirmationViewData.path,
    {},
    200,
    {
        status: true,
        title: '資料載入成功',
        message: '取得成功',
        errorCode: '',
        result: {
            data: {
                cname: '測試姓名',
                birthday: '19851225',
                sex: 'male',
                education: '大學',
                ssn: 'A123456789',
                IDCheck_P: 'Y',
                IDCheck_T: 'N',
                IDCheck_Y: '1985',
                IDCheck_M: '12',
                IDCheck_D: '25',
                birthPlace: '台北市',
                cityOfBirth: '台北市',
                mobilephone: '0912345678',
                email: 'test@example.com',
                domicileaddress: '台北市信義區市府路45號',
                mailingaddress: '台北市信義區市府路45號',
                homeaddress: '台北市大安區和平東路100號',
                hometelephone: '02-21234567',
                hometelephoneext: '123',
                emergencycontact: '王小明',
                emergencycontactphone: '0987654321',
                emergencyrelation: '友人',
                isCompanyRequired: 'y',
                occupationCode: 'A123',
                occupationOther: '',
                occupation: '工程師',
                companyname: '範例科技有限公司',
                companytelephone: '02-29876543',
                companytelephoneext: '456',
                companyaddress: '台北市內湖區瑞光路88號',
                jobTitleCode: 'J123',
                jobtitle: '經理',
                bolInvestmentExp: 'Y',
                yrsStockExp: '2',
                yrsBondExp: '1',
                yrsRealEstateExp: '0',
                yrsFutureExp: '0',
                yrsOtherExpDetail: '',
                yrsOtherExp: '1',
                amountYearlyIncome: '1000000',
                amountFamilyIncome: '2000000',
                mainMoneySource: '薪資',
                mainMoneySourceDetail: '',
                bolOwnHouse: 'Y',
                amountHouseValue: '5000000',
                bolHasMortgage: 'Y',
                amountMortgage: '2000000',
                bolDepositeMonthEndLeft: 'Y',
                amountDepositeMonthEndLeft: '100000',
                bolOtherAsset: 'N',
                otherAssetDetail: '',
                amountOtherAsset: '0',
                amountTotalAsset: '8000000'
            }
        }
    }
];
export default ConfirmationViewData;
